export const ENVIRONMENT_HEADER = 'X-Update-Environment';
export const API_KEY_HEADER = 'X-Api-Key';
